import type { BrowserQueryString } from '@/scopes/common/infrastructure/query-strings/types';
import { type SearchStoreApi } from '@/scopes/search/search/infrastructure/store/store';
import { searchPageQueryBuilder } from '@/scopes/search/search/infrastructure/browser/searchPageQueryBuilder';

interface Dependencies {
  store: SearchStoreApi;
  browserQuery: BrowserQueryString;
}

export function filterSelectionQueryParamHandler({ store, browserQuery }: Dependencies) {
  function update() {
    const { pagination, filterSelection, sorting } = store.getState();
    const queryParams = searchPageQueryBuilder.build({ pagination, filterSelection, sorting });

    browserQuery.set(queryParams);
  }

  return { update };
}
